import XLSX from 'xlsx';
import excelIcon from '../assets/img/fileTypes/excel.svg';

const exportForExcel = ({ fileName = 'report', exportType = 'xlsx', data }) => {
    var jsonToXls = XLSX.utils.json_to_sheet(data);

    var wb = XLSX.utils.book_new() // make Workbook of Excel
    XLSX.utils.book_append_sheet(wb, jsonToXls, fileName);
    XLSX.writeFile(wb, fileName + '.' + exportType);
}

export { excelIcon, exportForExcel as default }